import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import AccountingContainer from "@/screens/CompanySettings/Accounting/containers/AccountingContainer"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/accounting")({
  component: AccountingContainer,
})
